import styled from 'styled-components'

import FONTS from 'constants/fonts'


export const HoursNotificationWrap = styled.div`
  max-width: 640px;
  margin: 20px auto 0;
`

export const HoursNote = styled.span`
  font-size: ${FONTS.PARAGRAPHTINY};
  font-style: italic;
`
